export default {"src":"/_next/static/media/youtube-icon.2ccae6e0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};